import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@structural-climbing/ui'

/**
 * One setup step: the content, and a footer with Back on the left and the way
 * forward on the right. On a phone the footer sticks to the bottom, so the
 * button is always under the thumb.
 */
export function StepPanel({
  children,
  onBack,
  backLabel,
  primary,
  note,
  error,
}: {
  children: ReactNode
  onBack?: () => void
  backLabel?: string
  primary?: { label: string; onPress: () => void; isLoading?: boolean; isDisabled?: boolean }
  note?: string
  error?: string | null
}) {
  const { t } = useTranslation()
  return (
    <section className="flex min-w-0 flex-1 flex-col rounded-2xl border border-divider bg-content1">
      <div className="flex flex-1 flex-col gap-5 p-5 sm:p-7">
        {children}
        {error && <p className="text-sm text-danger">{error}</p>}
      </div>
      {(onBack || primary) && (
        <div className="sticky bottom-0 flex flex-wrap items-center justify-between gap-3 rounded-b-2xl border-t border-divider bg-content1 px-5 py-4 sm:static sm:px-7">
          {onBack ? (
            <Button variant="light" onPress={onBack}>
              {backLabel ?? `← ${t('competitionSetup.back')}`}
            </Button>
          ) : (
            <span />
          )}
          <div className="flex flex-1 items-center justify-end gap-3">
            {note && <span className="hidden text-sm text-foreground/60 md:inline">{note}</span>}
            {primary && (
              <Button
                color="primary"
                className="font-semibold"
                isLoading={primary.isLoading}
                isDisabled={primary.isDisabled}
                onPress={primary.onPress}
              >
                {primary.label}
              </Button>
            )}
          </div>
        </div>
      )}
    </section>
  )
}
